import { Http, Response, URLSearchParams } from '@angular/http';
import { NgModule, Injectable, Inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { Model, ComponentType, ModelSelected } from '../entities/global/model';

@Injectable()
export class EquipmentService {
    public RequestResult: boolean = true;
    private ErrorResponse: any;

    constructor(private _http: Http) {
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

    /*
        Returns an array of all models
    */
    public getModelList(): Observable<ModelSelected[]> {
        return this._http.get("Api/GETApplication/getModelListForImplementTemplateSetup").share().map(
            (response: Response) => <ModelSelected[]>response.json()).catch(this.handleError);
    }

    /*
        Returns a list of all GET component types
    */
    public getGetComponentTypeList(): Observable<ComponentType[]> {
        return this._http.get("Api/GETApplication/getGetComponentTypeList").share().map(
            (response: Response) => <ComponentType[]>response.json()).catch(this.handleError);
    }

    /*
        Returns a list of all Dump Body component types
    */
    public getDumpBodyComponentTypeList(): Observable<ComponentType[]> {
        return this._http.get("Api/GETApplication/getDumpBodyComponentTypeList").share().map(
            (response: Response) => <ComponentType[]>response.json()).catch(this.handleError);
    }

    
}